import lozad from 'lozad'

lozad('[data-background-image],[data-background-image-set]').observe()
